export enum LimitType {
	Users = 'users',
	Tenants = 'tenants',
	SAML = 'saml',
	AccessKeys = 'accessKeys',
	SMS = 'sms'
}

export interface IProjectLimits {
	mauExceeded: boolean;
	textExceeded: boolean;
	tenantExceeded: boolean;
	samlExceeded: boolean;
	accessKeyExceeded: boolean;
}
